import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import EditDocumentFormPage from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Documents/EditDocumentFormPage';
import { useDispatch } from 'react-redux';
import { documentsGetSingle } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Documents/Slices/Documents.slice';
import { useTypedSelector } from '@Features/store';
import { useUnitPermissions } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/useUnitPermissions';

type Props = {};

const EditDocument: React.FC<Props> = () => {
	const { id } = useParams<{ id: string; label: string }>();
	const dispatch = useDispatch();
	const {
		currentEntity,
		loaders: { getSingle },
	} = useTypedSelector((state) => state.Documents);
	const { canUpdate } = useUnitPermissions();
	const history = useHistory();
	useEffect(() => {
		if (!canUpdate) {
			history.goBack();
			return;
		}
		dispatch(documentsGetSingle({ id }));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (!canUpdate) return null;
	return (
		<div>
			{currentEntity && getSingle === 'fulfilled' && <EditDocumentFormPage />}
		</div>
	);
};

export default EditDocument;
